/**
 * @desc 分页
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(params: API.bus.tripartiteSystemAuth.page.Params, options?: any) {
  return updateResponse(
    http(URL + `/tripartiteSystemAuth/page`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
